import { tw } from "../../styling";

type DividerStyle = "dotted" | "solid" | "dashed";
type DividerHeight = 1 | 2 | 4;

type Props = {
	style?: DividerStyle;
	height?: DividerHeight;
	className?: string;
};

const dividerStyleMap: Record<DividerStyle, string> = {
	dotted: tw`border-dotted`,
	solid: tw`border-solid`,
	dashed: tw`border-dashed`,
};

const dividerHeightMap: Record<DividerHeight, string> = {
	1: tw`border`,
	2: tw`border-2`,
	4: tw`border-4`,
};

export const Divider = ({ className, style = "solid", height = 1 }: Props) => {
	return (
		<hr
			className={tw(
				"w-full",
				"border-foreground-divider",
				className,
				dividerStyleMap[style],
				dividerHeightMap[height],
			)}
		/>
	);
};
